import React from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { ToggleButton } from 'primereact/togglebutton';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Form, Field } from 'react-final-form';
import { calculateAge } from '../utils/calculateAge';

const Authority = ({ familyMember, sfd, fd, labels, isFormFieldValid, getFormErrorMessage }) => {
    return <Form onSubmit={(data, form) => {
        for (let key in data)
            familyMember[key] = data[key];
        familyMember.currentStep++;
        sfd(familyMember);
    }
    }
        initialValues={{...familyMember,
            takesBus: familyMember.takesBus || true,
        }}
        validate={(data) => {
            let error = {};
            let requiredFields = ["isSpouse"];
            if (Object.hasOwn(data, 'isSpouse') && !(data.isSpouse) && calculateAge(data.birthDate) < 18)
                requiredFields.push("parentalConsent");
            for (let f of requiredFields)
                if (!data[f] && data[f] !== false)
                    error[f] = labels['This field is required.'];
            if (Object.hasOwn(data, 'isSpouse') && !(data.isSpouse) && data.birthDate && calculateAge(data.birthDate) < 18 && !data.parentalConsent)
                error["parentalConsent"] = labels['Parental consent is required for minors'];
            if (data.isSpouse && fd.some(member => member.isSpouse && member.personID !== familyMember.personID))
                error['isSpouse'] = labels['Only one spouse is allowed'];
            if (data.isSpouse && calculateAge(data.birthDate) < 18)
                error['isSpouse'] = labels['Spouse must be at least 18 years old'];
            return error;
        }}
        render={({ handleSubmit }) => (
            <>
                <div className="">
                    <Field name={"isSpouse"}
                        render={({ input, meta }) =>
                            <div className="field">
                                <SelectButton
                                    {...input}
                                    options={[
                                        { label: labels.spouse, value: true, disabled: fd.some(member => member.isSpouse && !familyMember.isSpouse) },
                                        { label: labels.child, value: false }
                                    ]}
                                    optionDisabled='disabled'
                                    className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                />
                                {getFormErrorMessage(meta)}
                            </div>
                        } />
                    <Field name={"parentalConsent"}
                        type="checkbox"
                        render={({ input, meta }) => {
                            return <>{calculateAge(familyMember.birthDate) < 18 &&
                                (<div className="field" >
                                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}
                                        dangerouslySetInnerHTML={{ __html: labels.parentalConsent }} /><br />
                                    <ToggleButton
                                        onLabel={labels.yes}
                                        offLabel={labels.no}
                                        onIcon="pi pi-check"
                                        offIcon="pi pi-times"
                                        invalid={isFormFieldValid(meta)}
                                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                        {...input}
                                    /><br />
                                    {getFormErrorMessage(meta)}
                                </div>)}</>;
                        }
                        } />
                </div>
                <div className="flex py-4 gap-2">
                    <Button
                        type="button"
                        label={labels.back}
                        severity="secondary"
                        icon="pi pi-arrow-left"
                        onClick={() => { familyMember.currentStep--; sfd(familyMember) }} />
                    <Button
                        type="button"
                        label={labels.next}
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        onClick={handleSubmit} />
                </div>
            </>
        )}
    />
};
export default Authority;